
<template>

	<div class="main-container">

		<showAttr ref="show_attr"/>

		<b-navbar class="px-0">
	
			<b-navbar-brand>

				<h4>{{title}}</h4>

			</b-navbar-brand>
			<b-nav pills class="menubar d-flex justify-content-end ml-auto">
	
				<b-nav-item v-if="with_show_attr" v-on:click="show_attr" variant="primary">Атрибуты</b-nav-item>
	
				<slot name="nav_items"/>
	
			</b-nav>
		</b-navbar>


		<!-- <div style="width: 100%; max-width: 100%; overflow-x: auto; overflow-y: auto;"> -->

		<b-table id="table" ref="table" sticky-header="97%" small hover :items="objects" :fields="attrs_visible" class="elements" :per-page="per_page" :current-page="set_page_local ? current_page : 1" style="min-width: 100%;flex: 1;"
			v-on:sort-changed="sort_changed" :sort-by="sort_by" :sort-desc="sort_desc" no-local-sorting>

			<template v-slot:head()="data">

				<div :align="data.field.align_header ? data.field.align_header : 'center'"><span v-html="data.label"/></div>

			</template>

			<template v-slot:cell()="data">

				<div :align="data.field.align ? data.field.align : 'center'">

					<div v-if="data.field.my_formatter" :let="desc = data.field.my_formatter(data)"><div :style="desc.style ? desc.style : ''">{{ desc.value }}</div></div>
					<div v-else-if="data.field.url"><b-link v-on:click="() => go_by_url(data.field.key, data.item)" variant="primary-outline">{{ data.value }}</b-link></div>
					<div v-else-if="data.field.type == 'array'"><div v-for="elem in data.value" :key="elem">{{ elem }}</div></div>
					<div v-else-if="data.field.type == 'bool'"><div v-if="data.value">Да</div></div>
					<div v-else-if="data.field.type == 'date'">{{ data.value | format_date }}</div>
					<div v-else-if="data.field.type == 'time'">{{ data.value | format_time }}</div>
					<div v-else-if="data.field.type == 'datetime'">{{ data.value | format_datetime }}</div>
					<div v-else><div class="keep-spaces">{{ data.value }}</div></div>

				</div>

			</template>

		</b-table>
		
		<b-row class="small px-3 natural-400" style="font-size: 0.75rem">
			<b-col cols="6">

					Найдено: {{ real_count }} записей. Показывать на странице по:
					<v-select v-model="per_page" class="v_select_up" :options="[5, 10, 50]" @input="set_per_page" :clearable="false" :searchable="false" style="width: 4.625rem;height: 1.5rem;display: inline-block" />

			</b-col>
		
			<b-col cols="6">

				<b-pagination align="right" v-model="current_page" :per-page="per_page" :total-rows="real_count" aria-controls="table" v-on:change="set_page" first-number last-number>
					<template #prev-text><b-icon icon="chevron-left"></b-icon></template>
					<template #next-text><b-icon icon="chevron-right"></b-icon></template>
				</b-pagination>

			</b-col>
		</b-row>

	</div>

</template>

<script>

import api from "../../../api"
import showAttr from "./show"

export default
{
	props :
	{
		objects : Array,
		attrs_all : Array,
		prefix : String, // Не обязательно
		with_show_attr : { type : Boolean, default : () => false },
		set_page_local : { type : Boolean, default : () => false },
		count : Number,
		title : { type : String, default : () => "" },
	},

	components :
	{
		showAttr,
	},

	data()
	{
		return {

			current_page : 1,
			per_page : 10,

			attrs : [],
			attrs_visible : [],

			is_sort : false,
			sort_by : null,
			sort_desc : null,

		}
	},

	watch :
	{
		attrs_all :
		{
			immediate : true,
			handler(attrs_all)
			{
				if(attrs_all)
				{
					var attrs = []
					var _attrs_all = api.deep_clone(attrs_all)

					_attrs_all.forEach(
						attr =>
						{
							if(this.prefix != null)
								attr.key = this.prefix + attr.key

							attrs.push(attr)
						})

					this.attrs = attrs
					this.attrs_visible = attrs
				}
			}
		}
	},

	computed :
	{
		real_count()
		{
			if(this.count != null)
				return this.count

			return this.objects.length
		},

		from()
		{
			return Math.min(( this.current_page - 1) * this.per_page + 1, this.real_count)
		},

		to()
		{
			return Math.min(this.current_page * this.per_page, this.real_count)
		},
	},

	filters :
	{
		format_date(value)
		{
			return api.format_date(value)
		},

		format_time(value)
		{
			return api.format_time(value)
		},

		format_datetime(value)
		{
			return api.format_datetime(value)
		},
	},

	methods :
	{
		set_per_page(per_page)
		{
			this.per_page = per_page
			this.current_page = 1

			this.$emit("page", { per_page : per_page, page : this.current_page })
		},

		set_page(page)
		{
			this.$emit("page", { per_page : this.per_page, page : page })
		},

		show_attr()
		{
			this.$refs.show_attr.execute()
		},

		go_by_url(key, data)
		{
			const url = this.attrs_all.find(attr => attr.key == key).url
			const router_name = url.router_name
			const query = url.make_query(data)
			var url_key = url.key

			if(url_key == null && url.make_key)
				url_key = url.make_key(data)

			this.$router.push(
			{
				name : router_name,
				params : { query : query, key : url_key },
				query : { query : query }
//				query : { key : url.key }, // Иначе 3731, комментарий Наты от 02.11.2023
			})
		},

		sort_changed(ctx)
		{
			if(! this.is_sort)
			{
				this.is_sort = true
			}

			this.objects = api.sort_objects_array_by_key(this.objects, ctx.sortBy, ctx.sortDesc)
		},
	}
}

</script>

<style>
.menubar .nav-item
{
	height: 2.5rem;
	border: 1px solid var(--bft-blue-200);
	border-radius: .25rem;
	box-sizing: border-box;
	display: flex;
	align-items: center;
}

.menubar .nav-item a
{
	padding-inline: .75rem;
}

.menubar
{
	gap: .5rem;
	padding-block: .5rem;
}
</style>
